import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BeachAccessIcon(props: IconProps) {
    return <Icon {...props} iconKey={"beach_access"}/>
}
